export default __webpack_public_path__ + "static/fb-share-dfef374a72956d9acb15ebcaaadbeae8.jpg";